import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const recipe = {
  fetchRecipeCompilations: lazyModuleMethod(
    () => import('./fetchRecipeCompilations'),
    'default'
  ),
  fetchRecipeCompilation: lazyModuleMethod(
    () => import('./fetchRecipeCompilation'),
    'default'
  ),
  createRecipeCompilation: lazyModuleMethod(
    () => import('./createRecipeCompilation'),
    'default'
  ),
  deleteRecipeCompilation: lazyModuleMethod(
    () => import('./deleteRecipeCompilation'),
    'default'
  ),
  fetchRecipeDishes: lazyModuleMethod(
    () => import('./fetchRecipeDishes'),
    'default'
  ),
  fetchRecipeDish: lazyModuleMethod(
    () => import('./fetchRecipeDish'),
    'default'
  ),
  updateRecipeStep: lazyModuleMethod(
    () => import('./updateRecipeStep'),
    'default'
  ),
  fetchRecipeIngredientsNorm: lazyModuleMethod(
    () => import('./fetchRecipeIngredientsNorm'),
    'default'
  ),
  fetchRecipeIngredientNorm: lazyModuleMethod(
    () => import('./fetchRecipeIngredientNorm'),
    'default'
  ),
  createRecipeIngredientNorm: lazyModuleMethod(
    () => import('./createRecipeIngredientNorm'),
    'default'
  ),
  deleteRecipeIngredientNorm: lazyModuleMethod(
    () => import('./deleteRecipeIngredientNorm'),
    'default'
  ),
  updateRecipeIngredientNorm: lazyModuleMethod(
    () => import('./updateRecipeIngredientNorm'),
    'default'
  ),
  fetchRecipes: lazyModuleMethod(() => import('./fetchRecipes'), 'default'),
  fetchRecipe: lazyModuleMethod(() => import('./fetchRecipe'), 'default'),
  deleteRecipe: lazyModuleMethod(() => import('./deleteRecipe'), 'default'),
  updateRecipe: lazyModuleMethod(() => import('./updateRecipe'), 'default'),
  bindRecipesToCompilation: lazyModuleMethod(
    () => import('./bindRecipesToCompilation'),
    'default'
  ),
  fetchRecipeIngredients: lazyModuleMethod(
    () => import('./fetchRecipeIngredients'),
    'default'
  ),
  updateRecipeCompilation: lazyModuleMethod(
    () => import('./updateRecipeCompilation'),
    'default'
  ),
  fetchRecipeProducts: lazyModuleMethod(
    () => import('./fetchRecipeProducts'),
    'default'
  ),
  fetchRecipeProduct: lazyModuleMethod(
    () => import('./fetchRecipeProduct'),
    'default'
  ),
  updateRecipeProduct: lazyModuleMethod(
    () => import('./updateRecipeProduct'),
    'default'
  ),
  updateRecipeIngredient: lazyModuleMethod(
    () => import('./updateRecipeIngredient'),
    'default'
  ),
  createRecipeIngredientsGroup: lazyModuleMethod(
    () => import('./createRecipeIngredientsGroup'),
    'default'
  ),
  updateRecipeIngredientsGroup: lazyModuleMethod(
    () => import('./updateRecipeIngredientsGroup'),
    'default'
  ),
  createRecipeIngredient: lazyModuleMethod(
    () => import('./createRecipeIngredient'),
    'default'
  ),
  createRecipeStep: lazyModuleMethod(
    () => import('./createRecipeStep'),
    'default'
  ),
  deleteRecipeIngredient: lazyModuleMethod(
    () => import('./deleteRecipeIngredient'),
    'default'
  ),
  deleteRecipeProduct: lazyModuleMethod(
    () => import('./deleteRecipeProduct'),
    'default'
  ),
  deleteRecipeStep: lazyModuleMethod(
    () => import('./deleteRecipeStep'),
    'default'
  ),
  fetchRecipeSteps: lazyModuleMethod(
    () => import('./fetchRecipeSteps'),
    'default'
  ),
  deleteRecipeIngredientsGroup: lazyModuleMethod(
    () => import('./deleteRecipeIngredientsGroup'),
    'default'
  ),
  createRecipeProduct: lazyModuleMethod(
    () => import('./createRecipeProduct'),
    'default'
  ),
  createRecipe: lazyModuleMethod(() => import('./createRecipe'), 'default'),
  deleteRecipeDish: lazyModuleMethod(
    () => import('./deleteRecipeDish'),
    'default'
  ),
  updateRecipeDish: lazyModuleMethod(
    () => import('./updateRecipeDish'),
    'default'
  ),
  createRecipeDish: lazyModuleMethod(
    () => import('./createRecipeDish'),
    'default'
  ),
  searchRecipeProducts: lazyModuleMethod(
    () => import('./searchRecipeProducts'),
    'default'
  ),
}
